module.exports = __webpack_public_path__ + "img/icon-ship-selected.c217dc6.png";